<template>
  <div class="block-list-heading">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'block-list-heading'
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.block-list-heading {
  align-items: center;
  background: $color-bg-medium;
  color: $color-text-light;
  display: flex;
  height: 3.6rem;
  width: 100%;

  & > div {
    font-size: 1.4rem;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BlockListHeading.vue